import { Container, RenderLayer } from "pixi.js";
import SignController from "../services/SignController";

export class DefaultSign {
  private readonly width = 1920;
  private readonly height = 1080;

  private readonly controller: SignController;
  private readonly stage: Container;

  private readonly layers = {
    background: new RenderLayer(),
    counter: new RenderLayer(),
    history: new RenderLayer(),
    win: new RenderLayer(),
  };

  constructor(stage: Container, controller: SignController) {
    this.stage = stage;
    this.controller = controller;
  }
}
